<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('ediTemplate.title') }}
    v-row
      v-col
        v-text-field(
          :label="$t('ediTemplate.url')",
          v-model="instance.url"
        )
    v-row
      v-col(cols="6")
        v-text-field(
          v-model="header.key",
          @keydown.enter="addHeader",
          :label="$t('ediTemplate.headerKey')",
        )
      v-col(cols="6")
        v-text-field(
          v-model="header.value",
          @keydown.enter="addHeader",
          :label="$t('ediTemplate.headerValue')",
        )
      v-chip(v-for="(v, k) in instance.headers", close, @click:close="$delete(instance.headers, k)") {{ k }} : {{ v }}
    code-editor(
      v-model="instance.body",
      language="application/json"
    )
</template>

<script>
export default {
  props: ['value'],
  data: function ()  {
    return {
      header: { key: '', value: '' },
      initialObject: {
        headers: {},
        url: 'https://vgs5301.geobus.geodis.org:8443/SCOPartnersGatewayService/api/v1/data/push',
        markdown: '',
        isRazor: true,
      },
      instance: {},
    }
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      },
    }
  },
  methods: {
    addHeader () {
      this.instance.headers[this.header.key] = this.header.value;
      this.header = { key: '', value: '' };
    },
  },
  created() {
    this.instance = { ...this.initialObject, ...this.value };
  },
}
</script>
